export const TrashSVG = () => (
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M17.4393 27.5291C17.6073 20.2585 22.5531 14.9781 28.717 14.9781C28.7142 14.9528 28.6407 5.53977 28.631 5.5C15.2107 5.5 8.10238 16.7841 8.20134 27.6918C8.20653 27.6847 17.459 27.5377 17.4393 27.5291Z"
            fill="#FCE6AF"
        />
        <path d="M42 31.5V72" stroke="#0A41FA" strokeWidth="5" />
        <path d="M58 31.5V72" stroke="#0A41FA" strokeWidth="5" />
        <line x1="19" y1="21" x2="81" y2="21" stroke="#0A41FA" strokeWidth="5" />
        <line x1="37" y1="16" x2="63" y2="16" stroke="#0A41FA" strokeWidth="5" />
        <path
            d="M25 20.5V76C25 79.3137 27.6863 82 31 82H69C72.3137 82 75 79.3137 75 76V20.5"
            stroke="#0A41FA"
            strokeWidth="5"
        />
        <path
            d="M91.588 40.3646C92.1235 38.6255 92.1397 36.7915 91.6204 35.0841C91.1012 33.3766 90.0952 31.8589 88.7159 30.7205C87.3367 29.5822 85.6329 28.9024 83.848 28.7601C82.0631 28.602 80.2458 28.9815 78.6556 29.851C77.0654 30.7205 75.7511 32.0328 74.8911 33.6296C74.0311 35.2264 73.6579 37.0287 73.8201 38.8152C73.9824 40.6017 74.6801 42.2934 75.816 43.6846C76.9518 45.0601 78.4771 46.0719 80.1971 46.562C82.5175 47.226 84.9839 46.9573 87.1257 45.7873C89.2839 44.6174 90.874 42.6728 91.588 40.3646Z"
            fill="#F6AED5"
        />
        <path
            d="M86.5134 78.8989C78.7295 81.3316 74.065 88.5553 76.095 95.0334L90.189 90.6285L86.5134 78.8989Z"
            fill="#62B7D0"
        />
    </svg>
);
